import { DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutManualSettlementPostingReport extends Layout {
    excludabletextboxPayee: ExcludableTextbox;
    sourceManualSettlementPosting: DataSource;
    textboxCutoffDate: Textbox;
}
